export default function unCapitalize(str) {
    return str ? `${str.charAt(0).toLowerCase()}${str.slice(1)}` : null;
}
